





import {Component, Vue, Prop, Ref} from 'vue-property-decorator';
import editor from './Editor.vue';

@Component({
  components: {
    editor
  }
})
export default class SummernoteLite extends Vue {
  @Prop({required: false})
  private readonly options?: any;
  @Prop({required: false, default: false})
  private readonly disable?: boolean;
  @Prop({required: false, default: ''})
  private readonly data?: string;
  @Prop({required: false})
  private readonly mallNo!: string;
  @Prop({required: false})
  private readonly editorId?: string;
  @Prop({required: false, default: 'COMMON_FILE_SIZE_ERR_IMG'})
  private readonly checkSizeMsg?: string;
  @Prop({required: false, default: 'COMMON_FILE_TYPE_ERR_IMAGE'})
  private readonly checkTypeMsg?: string;

  @Ref()
  private readonly summernote: editor;

  private focus() {
    (this.$refs.summernote as any).focus();
  }
  public getHtml(){
    return this.summernote.getHtml();
  }
}
